<template>
  <v-dialog v-model="show" width="785px" persistent scrollable>
    <div class="modal">
      <v-card flat :loading="status_action === 'loading'">
        <ValidationObserver ref="validator">
          <v-row>
            <div class="icon-modal table-cell">
              <v-layout class="delete-warning-icon">
                <v-flex>
                  <img :src="require('@/assets/img/warning.svg')" alt/>
                </v-flex>
              </v-layout>
            </div>
            <v-col class="table-cell modal-content" style="padding: 34px 43px 10px 30px !important;">
              <div class="d-flex justify-space-between">
                <h6 class="modal-title mb-5" style="position: relative;
    top: -8px;">Delete Agent</h6>
              </div>
              <p style="position: relative;
    top: -4px;line-height: 14px !important;">This agent will no longer have the ability to access KIEY or its previous
                conversations.</p>

              <p>
                <b>
                  Are you sure you wish to delete this agent?
                </b>
              </p>

              <div class="mt-7">
                <label style="position: relative;
    top: -4px;">Assign a user to take over this agents contacts:</label>
              </div>

              <div class="custom-select-margin">
                <v-select
                    :items="filteredAgent"
                    v-model="selectedUser"
                    class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                    name="type"
                    type="text"
                    placeholder="Select one user"
                    :multiple="false"
                    :disabled="status_action === 'loading'"
                    :readonly="status_action === 'loading'"
                    @change="onChangeSelected"
                >
                  <template v-slot:append>
                    <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                  </template>
                </v-select>
              </div>

              <div v-if="hasSomeOwner" class="mt-7">
                <label style="position: relative;
    top: -4px;">Assign a user to take over the Owner role:</label>
              </div>

              <div v-if="hasSomeOwner" class="custom-select-margin">
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <v-select
                      :items="filteredOwner"
                      v-model="selectedOwner"
                      :error-messages="errors"
                      class="label-custom mt-0 pt-0 mr-3 pr-3 custom-input-position-text change_bord especial_border custom-select-options"
                      name="type"
                      type="text"
                      placeholder="Select one user"
                      :multiple="false"
                      :disabled="status_action === 'loading'"
                      :readonly="status_action === 'loading'"
                      @change="onChangeOwner"
                  >
                    <template v-slot:append>
                      <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div class="mt-5 mb-5 buttons d-flex">
                <v-btn
                    class="btn-blanco few mt-5 mr-6"
                    rounded
                    depressed
                    @click="transfer"
                    style="width:160px;position: relative;left: -1px;"
                    :loading="status_action === 'loading'"
                    :disabled="status_action === 'loading'"
                >Yes
                </v-btn>
                <v-btn
                    class="btn-azul few mt-5"
                    rounded
                    depressed
                    @click="close"
                    style="width:160px;position: relative;left: -7px;"
                    :loading="status_action === 'loading'"
                    :disabled="status_action === 'loading'"
                >No
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card>
    </div>
  </v-dialog>
</template>
<script>
  import {mapState, mapActions} from "vuex";
  import {ValidationObserver, ValidationProvider} from "vee-validate";

  export default {
    props: ['show', 'hide', 'selected'],
    components: {ValidationObserver, ValidationProvider},
    data() {
      return {
        selectedUser: null,
        selectedOwner: null,
        filteredAgent: [],
        filteredOwner: [],
      }
    },
    mounted() {
//
    },
    computed: {
      ...mapState({
        status_action: state => state.Users_list.status_action,
      }),
      hasSomeOwner() {
        return this.selected.find(x => ["vendor", "owner"].includes(x.user_role))
      },
    },
    watch: {
      selected(data) {
        const self = this;
        self.filteredAgent = [];
        for (const agent of self.$store.getters["Users_list/agentsToTransfer"]) {
          if (data.findIndex(a => a.id === agent.value) === -1) {
            self.filteredAgent.push({
              ...agent
            });
          }
        }

        self.filteredOwner = [];
        for (const agent of self.$store.getters["Users_list/agentsToTransfer"]) {
          if (data.findIndex(a => a.id === agent.value) === -1) {
            self.filteredOwner.push({
              ...agent
            });
          }
        }
      },
      filteredAgent(data) {
        const self = this;
        self.selectedUser = null;

        if (data.length > 0) {
          self.selectedUser = data[0]['value'];
        }
      },

      filteredOwner(data) {
        const self = this;
        self.selectedOwner = null;

        if (data.length > 0) {
          self.selectedOwner = data[0]['value'];
        }
      },
    },
    methods:
      {
        ...mapActions({get_users: "Users_list/get_users"}),
        close: function () {
          this.hide();
        },
        onChangeSelected(data) {
          const self = this;
          self.selectedUser = data;
        },
        onChangeOwner(data) {
          const self = this;
          self.selectedOwner = data;
        },
        setter() {
          const self = this;
          self.$emit("setter");
        },
        async transfer() {
          if (!await this.$refs.validator.validate()) {
            return;
          }
          const self = this;
          if (self.selectedUser) {
            self.$store.dispatch('Users_list/delete_transfer', {
              transfer_to: self.selectedUser,
              users: self.selected,
              transfer_owner: self.selectedOwner
            }).then(function (response) {
              if (response) {
                self.close();
                self.$store.dispatch("Users_list/clear_data", true);
                self.setter();
                self.get_users("agent");
              }
            });
          }
        }
      }
  }
</script>